<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="rocket"/>
          {{$t('emailCampaign')}}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="filterFormModel.status" @input="load">
          <b-tab :title="$t('all')"></b-tab>
          <b-tab :title="$t('draft')"></b-tab>
          <b-tab :title="$t('started')"></b-tab>
          <b-tab :title="$t('sending')"></b-tab>
          <b-tab :title="$t('finished')"></b-tab>
          <b-tab :title="$t('waitToDelete')"></b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <client-select :model="filterFormModel" attribute="client" class="mr-1 mb-1" @input="load"></client-select>
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-4">{{ $t('info') }}</div>
            <div class="col-lg-4">{{ $t('status') }}</div>
            <div class="col-lg-2">{{ $t('result') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-4">
              <p><b>Mã: </b><span>{{item._id}}</span></p>
              <p v-if="item.client.companyName"><b>{{$t('companyName')}}</b>: <span> {{item.client.companyName}} </span></p>
              <p><b>{{$t('domain')}}: </b><span>{{ item.client.domain }}</span></p>
              <p><b>{{ $t('name') }}: </b><span>{{ item.name }}</span></p>
            </div>
            <div class="col-lg-4">
              <p>
                <label v-if="item.doneSendingTime" class="badge badge-success">{{$t('finished')}}</label>
                <label v-else-if="item.sendTime" class="badge badge-warning">{{$t('sending')}}</label>
                <label v-else-if="item.startTime" class="badge badge-primary">{{$t('started')}}</label>
                <label v-else class="badge badge-secondary">{{$t('draft')}}</label>
                <label v-if="item.scheduledDelTime" class="badge badge-danger ml-1">{{$t('waitToDelete')}}</label>
              </p>
              <p><b>{{$t('createTime')}}: </b><span>{{item.createTime | moment('DD/MM/YYYY HH:mm')}}</span></p>
              <p v-if="item.startTime"><b>{{$t('startTime')}}: </b><span>{{item.startTime | moment('DD/MM/YYYY HH:mm')}}</span></p>
              <p v-if="item.sendTime"><b>{{$t('sendTime')}}: </b><span>{{item.sendTime | moment('DD/MM/YYYY HH:mm')}}</span></p>
              <p v-if="item.doneSendingTime "><b>{{$t('finishTime')}}: </b><span>{{item.doneSendingTime  | moment('DD/MM/YYYY HH:mm')}}</span></p>
              <p v-if="item.scheduledDelTime"><b>{{$t('scheduledDelTime')}}: </b><span>{{item.scheduledDelTime | moment('DD/MM/YYYY HH:mm')}}</span></p>
            </div>
            <div class="col-lg-2">
              <p>
                <b>{{$t('total')}}: </b>
                <b-spinner v-if="resultLoading" small></b-spinner>
                <span v-else-if="smss[item._id]">{{smss[item._id].total | numFormat}}</span>
                <span v-else>0</span>
              </p>
              <p>
                <b>{{$t('notSent')}}: </b>
                <b-spinner v-if="resultLoading" small></b-spinner>
                <span v-else-if="smss[item._id]">{{smss[item._id].notSent | numFormat}}</span>
                <span v-else>0</span>
              </p>
              <p>
                <b>{{$t('success')}}: </b>
                <b-spinner v-if="resultLoading" small></b-spinner>
                <span v-else-if="smss[item._id]">{{smss[item._id].success | numFormat}}</span>
                <span v-else>0</span>
              </p>
              <p>
                <b>{{$t('sending')}}: </b>
                <b-spinner v-if="resultLoading" small></b-spinner>
                <span v-else-if="smss[item._id]">{{smss[item._id].sending | numFormat}}</span>
                <span v-else>0</span>
              </p>
              <p>
                <b>{{$t('error')}}: </b>
                <b-spinner v-if="resultLoading" small></b-spinner>
                <span v-else-if="smss[item._id]">{{smss[item._id].failure | numFormat}}</span>
                <span v-else>0</span>
              </p>
            </div>
            <div class="col-lg-2">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col">
                    <button @click="update(item._id, 'pause')" type="button" class="btn btn-sm btn-secondary mr-1" v-if="item.startTime && !item.doneSendingTime">
                      <font-awesome-icon icon="stop"/>&nbsp;{{ $t('pause') }}
                    </button>
                  </div>
                  <div class="c-buttons__col">
                    <button @click="update(item._id, 'finish')" type="button" class="btn btn-sm btn-warning mr-1" v-if="item.startTime && !item.doneSendingTime">
                      <font-awesome-icon icon="stop"/>&nbsp;{{ $t('finish') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
  </main>
</template>

<script>
import List from '../../mixins/List';
import CRUD from "../../mixins/CRUD";
import ClientSelect from "../../components/ClientSelect";

export default {
  components: {ClientSelect},
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/email-campaign',
      defaultFilterFormModel: {
        keyword: null,
        type: null
      },
      resultLoading: false,
      smss: {},
      afterLoad(){
        this.getResults();
      },
    }
  },
  methods: {
    update(id, action) {
      this.$swal({
        title: this.$t('campaignFinishConfirm'),
        icon: "info",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          let loader = this.$loading.show();
          this.$service.put(this.service + '/' + action +'/' + id).then(response => {
            if (response.data) {
              this.load();
              this.$swal({
                title: this.$t('finishSuccess'),
                icon: 'success',
                toast: true,
                position: 'top-end',
                timer: 5000,
              });
            } else {
              this.$swal({
                title: this.$t('error'),
                text: this.$t('finishFailed'),
                icon: 'error'
              });
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            loader.hide();
          });
        }
      });
    },
    getResults() {
      this.resultLoading = true;
      let ids = this.items.map(item => {
        return item._id;
      })
      if (ids && ids.length) {
        this.$service.post(this.service + "/contact-count", {ids: ids}).then(response => {
          this.smss = {};
          response.data.forEach(item => {
            this.smss[item._id] = item;
          });
        }).finally(() => {
          this.resultLoading = false;
        });
      }
    },
  },
  i18n: {
    messages: {
      en: {
        emailCampaign: 'Email campaign',
        ads: 'Ads',
        care: 'Care',
        draft: 'Draft',
        started: 'Started',
        sending: 'Sending',
        finished: 'Finished',
        companyName: 'Company name',
        info: 'Campaign info',
        status: 'Status',
        result: 'Result',
        createTime: 'Create time',
        startTime: 'Start time',
        finishTime: 'Finish time',
        sendTime: "Send time",
        type: 'Campaign type',
        adsCampaignConfirmConfirm: 'Are you sure to confirm this ads campaign?',
        confirmSuccess: "Campaign confirmed!",
        confirm: 'Confirm',
        finish: 'Finish',
        finishSuccess: 'Campaign finished!',
        finishFailed: 'Campaign finished failed!',
        campaignFinishConfirm: 'Are you sure to finish this campaign?',
        rollBack: 'Roll back',
        adsCampaignRollBackConfirm: 'Are you sure to roll back this campaign',
        rollBackSuccess: 'Campaign rolled back!',
        rollBackFailed: 'Fail to roll back',
        notSent: "Not sent",
        pause: "Pause",
        waitToDelete: "Wait to delete",
        scheduledDelTime: "Scheduled delete",
      },
      vi: {
        emailCampaign: 'Chiến dịch Email',
        ads: 'Quảng cáo',
        care: 'CSKH',
        draft: 'Nháp',
        started: 'Đã bắt đầu',
        sending: 'Đang gửi',
        finished: 'Đã kết thúc',
        companyName: 'Tên KH',
        info: 'Thông tin chiến dịch',
        status: 'Trạng thái',
        result: 'Kết quả',
        createTime: 'Tạo lúc',
        startTime: 'Bắt đầu lúc',
        finishTime: 'Hoàn thành lúc',
        sendTime: "Thời gian gửi",
        type: 'Loại chiến dịch',
        adsCampaignConfirmConfirm: 'Hãy đảm bảo chắc chắn rằng bên cung cấp dịch vụ nhắn tin quảng cáo đã xác nhận nội dung tin nhắn là hợp lệ. Hành động xác nhận này sẽ trừ tiền trong tài khoản của khách hàng!',
        confirmSuccess: "Chiến dịch đã được xác nhận!",
        confirm: 'Xác nhận',
        finish: 'Hoàn thành',
        finishSuccess: 'Chiến dịch đã hoàn thành!',
        finishFailed: 'Có lỗi xảy ra! Chiến dịch chưa hoàn thành!',
        campaignFinishConfirm: 'Bạn có chắc muốn hoàn thành chiến dịch này?',
        rollBack: 'Quay lại',
        adsCampaignRollBackConfirm: 'Bạn có chắc muốn roll back chiến dịch này?',
        rollBackSuccess: 'Chiến dịch đã được roll back',
        rollBackFailed: 'Roll back thất bại',
        notSent: "Chưa gửi",
        pause: "Dừng",
        waitToDelete: "Chờ xoá",
        scheduledDelTime: "Hẹn giờ xoá",
      }
    }
  },
};
</script>